import React from 'react';
import './DevTable.scss';

const DevTable = () => {
  return (
    <div>DevTable</div>
  )
}

export default DevTable